"use strict";
function convertCamelCase(name) {
    return name ? name.replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function (str) { return str.toUpperCase(); }) :
        null;
};

export default convertCamelCase;